module.exports = __webpack_public_path__ + "img/sun.445becb8.png";